if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        const content = this.querySelector('[role="document"]');
        // Keep image clicks from triggering ModalDialog's mouse-to-close handler.
        content.addEventListener('pointerup', event => {
          if (event.target.matches('img[data-media-id]')) event.stopPropagation();
        });
        content.addEventListener('click', event => {
          if (event.target.matches('img[data-media-id]')) this.toggleZoom();
        });
        content.addEventListener('keydown', event => {
          if ((event.key === 'Enter' || event.key === ' ') && event.target === content) {
            event.preventDefault();
            this.toggleZoom();
          }
        });
      }

      toggleZoom() {
        if (!this.querySelector('img.active')) return;
        this.classList.toggle('dhs-media-zoomed');
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.classList.remove('dhs-media-zoomed');
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0;
        container.scrollLeft = 0;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
